import {objectFromEntries} from '@benchling/js-utils';

import {assert} from 'Asserts';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PIPELINE_STEP_SHAPES} from 'pipelines/GeneratedPipelineStepShapes';
import {StepConfigShape} from 'pipelines/StepShapeUtils';
import {JSONValue} from 'util/Types';

import {STEP_CONFIG_SETTINGS} from '../step-config-settings/StepConfigSettings';
import {ShapeUISchema, getFieldSettingsIfPresent} from '../StepConfigEditorTypes';
import {stepTypeIsConfigEditorSupported} from '../stepTypeIsConfigEditorSupported';
import jsonSpecToInitialValue from './jsonSpecToInitialValue';

export function makeInitialConfigStateFromConfigShape(
  configShape: StepConfigShape,
  uiSchema: ShapeUISchema
): Record<string, JSONValue> {
  return objectFromEntries(
    Object.entries(configShape).map(([variableName, jsonSpec]) => [
      variableName,
      jsonSpecToInitialValue(jsonSpec, getFieldSettingsIfPresent(uiSchema, variableName)),
    ])
  );
}

export default function makeInitialConfigState(
  stepType: PipelineStepType,
  stepVersion: number
): Record<string, JSONValue> {
  assert(
    stepTypeIsConfigEditorSupported(stepType, stepVersion) && stepType !== PipelineStepType.CHART_VIEW,
    `Unexpected ${stepType} v${stepVersion}`
  );
  const configVariablesShape = PIPELINE_STEP_SHAPES[stepType][stepVersion].config as StepConfigShape;

  const uiSchema: ShapeUISchema | undefined = STEP_CONFIG_SETTINGS[stepType][stepVersion]
    ?.uiSchema as ShapeUISchema;
  return makeInitialConfigStateFromConfigShape(configVariablesShape, uiSchema);
}
